import subMultiply from './operations/subMultiply.js'
import headerSumLines from './operations/headerSumLines.js'
import headerSumSubLines from './operations/headerSumSubLines.js'
import subAggregate from './operations/subAggregate.js'
import sumDateByDays from './operations/sumDateByDays.js'
import headerSetValue from './operations/headerSetValue.js'
import subTransfer from './operations/subTransfer.js'
import subCalcPayments from './operations/subCalcPayments.js'

import condiSetValue from './operations/condiSetValue.js'
import serieCalculate from './operations/serieCalculate.js'
import headerBasic from './operations/headerBasic.js'
import subBasic from './operations/subBasic.js'
import subDualAmount from './operations/subDualAmount.js'
import subGrossNet from './operations/subGrossNet.js'
import subSetFromRoot from './operations/subSetFromRoot.js'
import subDiscount from './operations/subDiscount.js'
import headerDiscount from './operations/headerDiscount.js'
import subAllocate from './operations/subAllocate.js'
import calculatePrice from './operations/calculatePrice.js'
import headerCalcField from './operations/headerCalcField.js'
import headerFindSign from './operations/headerFind.js'
import headerFormula from './operations/headerFormula.js'
import headerSlugField from './operations/headerSlugField.js'
import headerCountWhere from './operations/headerCountWhere.js'
import subCountArray from './operations/subCountArray.js'
import headerMerge from './operations/headerMerge.js'
import headerJoinLines from './operations/headerJoinLines.js'
import headerDescribeCondition from './operations/headerDescribeCondition.js'
import headerBuildCondition from './operations/headerBuildCondition.js'

function calcFields(data, operation, prevData = {}) {
  const { operationType } = operation
  let result = data

  if (operationType === 'header.basic') {
    result = headerBasic(result, operation)
  }
  
  if (operationType === 'sub.basic') {
    result = subBasic(result, operation)
  }

  if (operationType === 'sub.dualAmount') {
    result = subDualAmount(result, operation)
  }

  if (operationType === 'sub.grossNet') {
    result = subGrossNet(result, operation)
  }

  if (operationType === 'sub.setFromRoot') {
    result = subSetFromRoot(result, operation)
  }

  if (operationType === 'header.sumLines') {
    result = headerSumLines(result, operation)
  }

  if (operationType === 'header.sumSubLines') {
    result = headerSumSubLines(result, operation)
  }

  if (operationType === 'header.setValue') {
    result = headerSetValue(result, operation)
  }

  if (operationType === 'sub.multiply') {
    result = subMultiply(result, operation)
  }

  if (operationType === 'sub.aggregate') {
    result = subAggregate(result, operation)
  }

  if (operationType === 'sub.discount') {
    result = subDiscount(result, operation)
  }

  if (operationType === 'header.discount') {
    result = headerDiscount(result, operation)
  }

  if (operationType === 'sub.allocate') {
    result = subAllocate(result, operation)
  }

  if (operationType === 'sub.transfer') {
    result = subTransfer(result, operation, prevData)
  }

  if (operationType === 'condi.setValue') {
    result = condiSetValue(result, operation)
  }

  if (operationType === 'header.dateByDays') {
    result = sumDateByDays(result, operation, prevData)
  }

  if (operationType === 'sub.calcPayments') {
    result = subCalcPayments(result, operation, prevData)
  }

  if (operationType === 'serie.calculate') {
    result = serieCalculate(result, operation, prevData)
  }

  if (operationType === 'header.calcPrice') {
    result = calculatePrice(result, operation, prevData)
  }

  if (operationType === 'header.calcField') {
    result = headerCalcField(result, operation)
  }

  if (operationType === 'header.findSign') {
    result = headerFindSign(result, operation)
  }

  if (operationType === 'header.formula') {
    result = headerFormula(result, operation)
  }

  if (operationType === 'header.slugField') {
    result = headerSlugField(result, operation, prevData)
  }

  if (operationType === 'header.countWhere') {
    result = headerCountWhere(result, operation)
  }

  if (operationType === 'sub.countArray') {
    result = subCountArray(result, operation)
  }

  if (operationType === 'header.merge') {
    result = headerMerge(result, operation)
  }

  if (operationType === 'header.joinLines') {
    result = headerJoinLines(result, operation)
  }

  if (operationType === 'header.describeCondition') {
    result = headerDescribeCondition(result, operation)
  }

  if (operationType === 'header.buildCondition') {
    result = headerBuildCondition(result, operation)
  }

  if (result) return result
  //ALWAYS RETURN AT THE END OF ALL IF STATEMENTS
  return data;
}

export default calcFields
